<ion-modal>
    <ng-template>
        <ion-content scrollY="false">
            <div class="flex h-full flex-col bg-white text-base">
                <div class="flex-align-center align-center flex justify-center p-4">
                    <h2 class="text-base font-bold">
                        {{ 'CARD_BLOCKING_MODAL_TITLE' | translate }}
                    </h2>
                </div>

                <div class="flex-1 overflow-y-auto p-4">
                    <p>{{ 'CARD_BLOCKING_MODAL_DESCRIPTION_1' | translate }}</p>
                    <p>{{ 'CARD_BLOCKING_MODAL_DESCRIPTION_2' | translate }}</p>
                    <p>{{ 'CARD_BLOCKING_MODAL_LIST_TITLE' | translate }}</p>

                    <div class="mt-4 rounded-lg bg-grey-white_smoke p-4 dark:bg-contrast-black">
                        <ul
                            class="list-disc pl-4"
                            [innerHTML]="'CARD_BLOCKING_MODAL_LIST_ITEMS_INNER_HTML' | translate"></ul>
                    </div>

                    <p [innerHTML]="'CARD_BLOCKING_MODAL_CONFIRMATION_TEXT' | translate"></p>
                </div>

                <div class="p-4">
                    <button
                        class="vl-app-light:bg-secondary-button vl-app-light:text-black h-14 w-full rounded-lg bg-secondary font-bold text-white dark:bg-contrast-yellow dark:text-contrast-black"
                        [attr.aria-label]="'CARD_BLOCKING_MODAL_BUTTON' | translate"
                        (click)="blockCard()"
                        (keydown.enter)="blockCard()"
                        (keydown.space)="blockCard()"
                        tabindex="0">
                        {{ 'CARD_BLOCKING_MODAL_BUTTON' | translate }}
                    </button>

                    <button
                        class="vl-app-light:text-primary dark:!text-contrast-yellowmx-4 mt-2 h-14 w-full font-medium text-secondary dark:text-contrast-yellow"
                        [attr.aria-label]="'CARD_BLOCKING_MODAL_CANCEL' | translate"
                        (click)="closeModal()"
                        (keydown.enter)="closeModal()"
                        (keydown.space)="closeModal()"
                        tabindex="0">
                        {{ 'CARD_BLOCKING_MODAL_CANCEL' | translate }}
                    </button>
                </div>
            </div>
        </ion-content>
    </ng-template>
</ion-modal>
